import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_lrs_table_tracker_event.js";
//#region src/bite_log_lrs_table_tracker_event_helper.ts
var bite_log_lrs_table_tracker_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 1: return "get-ip-address-success";
		case 2: return "get-ip-address-error";
		case 3: return "get-ip-address-from-storage-cache";
		case 4: return "validate-ip-address-success";
		case 5: return "validate-ip-address-error";
		case 11: return "get-access-token-success";
		case 12: return "get-access-token-waiting";
		case 13: return "get-access-token-error";
		case 14: return "get-access-token-save-warning";
		case 15: return "get-access-token-save-success";
		case 16: return "validate-access-token-success";
		case 17: return "validate-access-token-error";
		case 21: return "activate-order-success";
		case 22: return "activate-order-error";
		case 23: return "activate-order-skipped";
		case 30: return "lrs-connected";
		case 31: return "lrs-disconnected";
		case 32: return "lrs-failed";
		case 40: return "lrs-state-changed";
	}
}
//#endregion
export { bite_log_lrs_table_tracker_event_helper_exports, name };

//# sourceMappingURL=bite_log_lrs_table_tracker_event_helper.js.map